/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { FeedbackInsightList } from "./FeedbackInsightList"
import { InsightList } from "./InsightList"
import type { ReportDataSet } from "./ReportDataSet"
import type { ReportModel } from "./ReportModel"
import type { ReportSimulationJob } from "./ReportSimulationJob"
import type { ReportTrainingData } from "./ReportTrainingData"
import type { ReportWorkflowGroup } from "./ReportWorkflowGroup"

export type Report = {
  readonly uuid: string
  /**
   * * `DATASET` - Dataset
   * * `TRAINING_DATA` - Training data
   * * `PREDICTION` - Predictions
   * * `WORKFLOW_PREDICTION` - Workflow Prediction
   * * `MODEL_PREDICTION` - Model Prediction
   * * `SIMULATION` - Simulation
   */
  type: Report.type
  /**
   * * `PENDING` - Pending
   * * `PREPARATION` - Preparation
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   */
  status?: Report.status
  readonly created_at: string
  created_by: string | null
  model: ReportModel | null
  workflow: ReportWorkflowGroup | null
  simulation_job: ReportSimulationJob | null
  /**
   * Represents the time the report was started
   */
  started_at?: string | null
  /**
   * Represents the time the report was failed
   */
  failed_at?: string | null
  /**
   * Represents the time the report was cancelled
   */
  cancelled_at?: string | null
  /**
   * Represents the time the report finished
   */
  succeeded_at?: string | null
  training_data: ReportTrainingData | null
  dataset: ReportDataSet | null
  predictions_start_time?: string | null
  predictions_end_time?: string | null
  export_job: string | null
  /**
   * Retrieve main insights (non feedback)
   */
  insights: Array<InsightList>
  /**
   * Retrieve insights that are feedback-related.
   */
  readonly feedback_insights: Array<FeedbackInsightList>
  failure_reason?: string | null
  labels: { count: number; label: string }[] | null
  features: { categorical: string[] | null; numerical: string[] | null } | null
}
export namespace Report {
  /**
   * * `DATASET` - Dataset
   * * `TRAINING_DATA` - Training data
   * * `PREDICTION` - Predictions
   * * `WORKFLOW_PREDICTION` - Workflow Prediction
   * * `MODEL_PREDICTION` - Model Prediction
   * * `SIMULATION` - Simulation
   */
  export enum type {
    DATASET = "DATASET",
    TRAINING_DATA = "TRAINING_DATA",
    PREDICTION = "PREDICTION",
    WORKFLOW_PREDICTION = "WORKFLOW_PREDICTION",
    MODEL_PREDICTION = "MODEL_PREDICTION",
    SIMULATION = "SIMULATION",
  }
  /**
   * * `PENDING` - Pending
   * * `PREPARATION` - Preparation
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   */
  export enum status {
    PENDING = "PENDING",
    PREPARATION = "PREPARATION",
    RUNNING = "RUNNING",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
  }
}
